var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-crown-module" },
    [
      _vm._t("title"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid--gap-1 rb-crowns" },
        [
          _vm.visible
            ? [
                !_vm.isMobile
                  ? [_vm._t("default")]
                  : [
                      _c(
                        "swiper",
                        {
                          staticClass: "col-12",
                          attrs: { config: _vm.swiperConfig, pagination: true },
                        },
                        _vm._l(_vm.swiperSlides, function (slot, index) {
                          return _c(
                            "rb-dynamic-swiper-slide",
                            { key: index, attrs: { index: index } },
                            [_vm._t("default")],
                            2
                          )
                        }),
                        1
                      ),
                    ],
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }